import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import React from 'react';
import Select from 'react-select';

const styles = () => ({
  dialogContent: {
    height: 500,
  },
  dialogBorder: {
    height: '20px',
  },
  title: {
    marginBottom: '.5em',
  },
});

class MoveVideoModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTermOptions: false,
      selectedOption: '',
      selectedTerm: '',
      termOptions: [],
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.handleClose}
          fullWidth
        >
          <div className={classes.dialogBorder} />
          <DialogTitle>
            <Typography variant="h4" className={classes.textCaps}>
              Select New Video Term
            </Typography>
          </DialogTitle>
          <div className={classes.dialogBody}>
            <DialogContent className={classes.dialogContent}>
              <Typography>
                <i>Start typing to see options</i>
              </Typography>
              <Select
                options={this.state.termOptions}
                styles={colourStyles}
                onChange={(val) => {
                  this.setState({
                    selectedOption: val,
                    selectedTerm: val.value,
                  });
                }}
                onInputChange={(val) => {
                  if (val && val.length && val.length > 0) {
                    this.setState({
                      termOptions: this.props.termOptions.filter(
                        (x) => x.value.substring(0, val.length) === val
                      ),
                    });
                  }
                }}
                value={this.state.selectedDefinitionTerm}
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  if (this.state.selectedTerm !== '')
                    this.props.moveVideo(this.state.selectedTerm);
                }}
                variant="outlined"
              >
                Move Video
              </Button>
              <Button onClick={this.props.handleClose} variant="outlined">
                Cancel
              </Button>
            </DialogActions>
          </div>
          <div className={classes.dialogBorder} />
        </Dialog>
      </div>
    );
  }
}

const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: '#F7F7F7',
    color: 'black',
    width: 400,
    marginTop: 10,
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
        ? 'grey'
        : isFocused
        ? '#F7F7F7'
        : null,
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled && (isSelected ? 'grey' : 'white'),
      },
    };
  },
};

export default withStyles(styles)(MoveVideoModal);
